import React, { forwardRef, useImperativeHandle, useState } from "react"
import { Table } from "reactstrap"
import moment from "moment"
import { getWorkspaceAuditList } from "helpers/backend_helper"

const formatBytes = bytes => {
  const num = Number(bytes)
  if (!num || isNaN(num)) return "-"
  const gb = num / 1e9
  return `${gb.toFixed(2)} GB`
}

const TableContainer = forwardRef((props, ref) => {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchList = async () => {
    setLoading(true)
    try {
      const res = await getWorkspaceAuditList({ page: 1, pagesize: 20 })
      const rows = res?.data || res?.Data || []
      setList(Array.isArray(rows) ? rows : [])
    } catch (error) {
      setList([])
    } finally {
      setLoading(false)
    }
  }

  useImperativeHandle(ref, () => ({
    refresh: fetchList,
  }))

  React.useEffect(() => {
    fetchList()
  }, [])

  return (
    <div className="table-responsive">
      <Table bordered hover>
        <thead className="table-light table-nowrap">
          <tr>
            <th>Machine</th>
            <th>Source</th>
            <th>Assessment Date</th>
            <th>Total Size</th>
            <th>Repositories</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {list?.length > 0 ? (
            list.map((row, idx) => (
              <tr key={row?.id || idx}>
                <td>{row?.machinename}</td>
                <td>{row?.source}</td>
                <td>
                  {row?.assessmentdate
                    ? moment(row.assessmentdate).format("DD-MM-YYYY")
                    : "-"}
                </td>
                <td>{formatBytes(row?.totalsizebytes)}</td>
                <td>{row?.repositorycount ?? "-"}</td>
                <td>
                  {row?.createdat
                    ? moment(row.createdat).format("DD-MM-YYYY HH:mm")
                    : "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center p-4">
                {loading ? "Loading..." : "No submissions yet"}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  )
})

TableContainer.displayName = "WorkspaceAuditTable"

export default TableContainer
